import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "efa9dcf8-8dc0-411b-93da-637e8625cc32",
    content: "Pure signal at one frequency",
    options: {},
  },
  {
    id: "cddb00ad-5b9b-46b4-941f-fcfb859bb3fb",
    content: "Dirac δ",
    options: {},
  },
  {
    id: "87685a36-5d56-4250-beea-59190380d9e4",
    content: "Rectangular window",
    options: {},
  },
  {
    id: "fae28b29-6da6-4fae-bbf9-0cb20e7420bd",
    content: "None of them",
    options: {},
  },
];

export const task: Task = {
  id: "ffb7d1c4-5cd8-477a-a7a8-51177b5b11f9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["cddb00ad-5b9b-46b4-941f-fcfb859bb3fb"],
};
